module.exports = __webpack_public_path__ + "img/search-no.02c61e5c.png";